document.addEventListener('DOMContentLoaded', () => {
	const showPrefix = '#show-';
	const dataMoreAttr = 'data-show-more';
	const dataLessAttr = 'data-show-less';

	const moreButtons = document.querySelectorAll<HTMLAnchorElement>(`[${dataMoreAttr}]`);

	moreButtons.forEach(button => {
		const targetId = button.getAttribute(dataMoreAttr);
		if (!targetId) {
			return;
		}

		const target = document.getElementById(targetId);
		if (!target) {
			return;
		}

		button.addEventListener('click', e => {
			e.preventDefault();

			target.classList.remove('hidden');
			button.classList.add('hidden');

			history.replaceState(null, '', `${showPrefix}${targetId}`);
		});
	});

	const lessButtons = document.querySelectorAll<HTMLAnchorElement>(`[${dataLessAttr}]`);

	lessButtons.forEach(button => {
		const targetId = button.getAttribute(dataLessAttr);
		if (!targetId) {
			return;
		}

		const target = document.getElementById(targetId);
		if (!target) {
			return;
		}

		const moreButton = document.querySelector<HTMLAnchorElement>(`[${dataMoreAttr}="${targetId}"]`);

		button.addEventListener('click', e => {
			e.preventDefault();

			target.classList.add('hidden');
			moreButton.classList.remove('hidden');

			history.replaceState(null, '', `#`);
		});
	});

	const hash = window.location.hash;
	if (hash.startsWith(showPrefix)) {
		const id = hash.slice(showPrefix.length);
		const target = document.getElementById(id);
		const button = document.querySelector<HTMLAnchorElement>(`[${dataMoreAttr}="${id}"]`);

		if (target) {
			target.classList.remove('hidden');
		}
		if (button) {
			button.classList.add('hidden');
		}
	}
});
